import React from 'react';
import Link from 'next/link';
import { useSelector } from 'store';
import styled from 'styled-components';

const MembershipInfo: React.FC = () => {
  const membershipServices = useSelector(
    state => state.service.membershipService,
  );
  const service = membershipServices[0];

  return (
    <div className="price-box">
      <PriceInnerBox>
        <strong style={{ fontSize: 32, lineHeight: '48px' }}>
          City Creator를 위한
          <br />
          공간&라이프스타일 
          <br />
          구독 서비스
        </strong>
        <p>로컬스티치 멤버십</p>
        <em>
          {Number(service.price).toLocaleString('ko-kr')}
          <span>원/월</span>
        </em>
        <Link href="/membership/join">
          <a>멤버십 신청하기</a>
        </Link>
      </PriceInnerBox>
    </div>
  );
};

const PriceInnerBox = styled.div`
  @media screen and (min-width: 900px) {
    margin-right: 100px;
  }
`;

export default MembershipInfo;
